export default __webpack_public_path__ + "static/media/inbox.937085e6.svg";